import {RequestResult, RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {Proxy, ProxyDestination} from "../../models/proxy";
import {PaginationResponse} from "../../models/paginationResponse";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export interface ProxiesSearchRequest {
    page: number;
    count: number;
    destination?: ProxyDestination | null;
    includeFailed?: boolean | null;
    linked?: boolean | null;
    unmapped?: boolean | null;
}

export interface ProxiesSearchResponse extends PaginationResponse<Proxy> {}

export async function proxiesSearchApi(request: ProxiesSearchRequest): Promise<RequestResultValue<ProxiesSearchResponse>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/proxies/search`, JSONbig.stringify(request));
    const text = await response.text();
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<ProxiesSearchResponse>(true, body as ProxiesSearchResponse);
    }
    return new RequestResultValue<ProxiesSearchResponse>(false);
}

export async function upsertProxyApi(proxy:Proxy): Promise<RequestResultValue<Proxy>> {
    const response=await HttpService.getInstance().requestPostAsync(`admin/proxies/upsert`, JSONbig.stringify(proxy));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<Proxy>(true, body as Proxy);
    }
    return new RequestResultValue<Proxy>(false);
}

export async function deleteProxyApi(id:number, toProxy?:number): Promise<RequestResult> {
    let url = `admin/proxies?id=${id}`;
    if (toProxy && toProxy > 0) {
        url = `${url}&toProxy=${toProxy}`;
    }
    const response = await HttpService.getInstance().requestDeleteAsync(url);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function resetFailedProxyApi(id:number): Promise<RequestResult> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/proxies/${id}/reset`, '{}');
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function unusedVendorProxiesApi(): Promise<RequestResultValue<UnusedVendorProxy[]>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/proxies/unused-vendor`);
    const text = await response.text();
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<UnusedVendorProxy[]>(true, body as UnusedVendorProxy[]);
    }
    return new RequestResultValue<UnusedVendorProxy[]>(false);
}

export interface UnusedVendorProxy {
    id: string;
    ip: string;
}